import React from "react";

import Box from "@mui/material/Box";

// Styles
import { useStyles } from "./DrawerHandle.styles";

const DrawerHandle = () => {
  const classes = useStyles();

  return <Box className={classes.drawerHandle} />;
};

export default DrawerHandle;
